export default {
    en: {
        header: "Catalog",
        prodList: {
            sorting: "Sort options",
            mySelect: {
                defaultOption: "Select from list",
            },
            byBrand: 'By Brand',
            byModel: 'By Model',
            byPrice: 'By Price',
            prodItems: {
                price: 'Price',
            },
            notFound: "Empty. There is no car with a description in English.",
        },
    },
    uk: {
        header: "Каталог",
        prodList: {
            sorting: "Сортировка",
            mySelect: {
                defaultOption: "Выберите из списка",
            },
            byBrand: 'По марке',
            byModel: 'По модели',
            byPrice: 'По цене',
            prodItems: {
                price: 'Цена',
            },
            notFound: "Пусто. Нет авто с описанием на украинском.",
        },
    },
}